export const UPDATE_LISTA_AVALIACAO_ALUNO = 'UPDATE_LISTA_AVALIACAO_ALUNO';
export const ADD_LISTA_AVALIACAO_ALUNO = 'ADD_LISTA_AVALIACAO_ALUNO';
export const SET_LISTA_AVALIACAO_ALUNO = 'SET_LISTA_AVALIACAO_ALUNO';
export const REMOVE_LISTA_AVALIACAO_ALUNO = 'REMOVE_LISTA_AVALIACAO_ALUNO';
export const SET_AVALIACAO_ALUNO = 'SET_AVALIACAO_ALUNO';
export const SET_LISTA_INIT = 'SET_LISTA_INIT';